export default __webpack_public_path__ + "static/media/doubt.bbcffac8.svg";